import { QueryClient } from '@tanstack/react-query';
import { ApiError } from './api-client';

/**
 * TanStack Query client — konfigurasi tunggal untuk seluruh aplikasi.
 *
 * - `staleTime: 60_000` — data dianggap fresh selama 1 menit; refetch
 *   hanya via invalidate/refetch eksplisit. Backend kita sudah
 *   mempunyai cache 10 menit, jadi frontend cukup layer sekunder.
 * - Retry OTOMATIS hanya untuk error jaringan/timeout, bukan 4xx yg
 *   memang gagal karena input user.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && error.status >= 400 && error.status < 500) {
          return false; // jangan retry 4xx
        }
        return failureCount < 2;
      },
    },
  },
});
